module.exports = __webpack_public_path__ + "static/helpscout-d06cb1d64edd8b203ea67b26105fb499.png";